// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://optimistic.etherscan.io/address/0xa8CD85030b6810663DDeD48aA15330F091fb4c9b
export const vyUSD__USD_Exchange_Rate = '0xa8CD85030b6810663DDeD48aA15330F091fb4c9b';

// https://optimistic.etherscan.io/address/0x13e3Ee699D1909E989722E753853AE30b17e08c5
export const ETH__USD = '0x13e3Ee699D1909E989722E753853AE30b17e08c5';

// https://optimistic.etherscan.io/address/0x524299Ab0987a7c4B3c8022a35669DdcdC715a10
export const WSTETH__ETH = '0x524299Ab0987a7c4B3c8022a35669DdcdC715a10';

// https://optimistic.etherscan.io/address/0x7CFB4fac1a2FDB1267F8bc17FADc12804AC13CFE
export const ONE__USD = '0x7CFB4fac1a2FDB1267F8bc17FADc12804AC13CFE';

// https://optimistic.etherscan.io/address/0x2fF1EB7D0ceC35959F0248E9354c3248c6683D9b
export const FLOW__USD = '0x2fF1EB7D0ceC35959F0248E9354c3248c6683D9b';

// https://optimistic.etherscan.io/address/0x5a61374950D4BFa5a3D4f2CA36FC1d23A92b6f21
export const TBTC__USD = '0x5a61374950D4BFa5a3D4f2CA36FC1d23A92b6f21';

// https://optimistic.etherscan.io/address/0x05950959B6d876ae0fed1BBe5Caa2d74d8659D59
export const sUSDe__USD = '0x05950959B6d876ae0fed1BBe5Caa2d74d8659D59';

// https://optimistic.etherscan.io/address/0xa29660E9B69da3399141cBDDFb819451b1d530Ae
export const Virtune_XRP_ETP__Proof_of_Reserves = '0xa29660E9B69da3399141cBDDFb819451b1d530Ae';

// https://optimistic.etherscan.io/address/0x8158d24603296Ce54ba903c7D5299E3B6744b555
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x8158d24603296Ce54ba903c7D5299E3B6744b555';

// https://optimistic.etherscan.io/address/0x895eAD698bc4C34ad2863a20932f0d5E7896F11c
export const Virtune_Staked_Solana_ETP__Proof_of_Reserves =
  '0x895eAD698bc4C34ad2863a20932f0d5E7896F11c';

// https://optimistic.etherscan.io/address/0xD702DD976Fb76Fffc2D3963D037dfDae5b04E593
export const BTC__USD = '0xD702DD976Fb76Fffc2D3963D037dfDae5b04E593';

// https://optimistic.etherscan.io/address/0x94A178f2c480D14F8CdDa908D173d7a73F779cb7
export const Synthetix_Aggregator_Debt_Ratio = '0x94A178f2c480D14F8CdDa908D173d7a73F779cb7';

// https://optimistic.etherscan.io/address/0x5CC26e6798A3b05525076913840aa07b1d65eE00
export const inETH__ETH_Exchange_Rate = '0x5CC26e6798A3b05525076913840aa07b1d65eE00';

// https://optimistic.etherscan.io/address/0x698B585CbC4407e2D54aa898B2600B53C68958f7
export const WSTETH__USD = '0x698B585CbC4407e2D54aa898B2600B53C68958f7';

// https://optimistic.etherscan.io/address/0x62f42f70ba85De1086476bB6BADE926d0E0b8a4C
export const GMX__USD = '0x62f42f70ba85De1086476bB6BADE926d0E0b8a4C';

// https://optimistic.etherscan.io/address/0xeEC819b2e155CC8FEae194F5129f767409e2327c
export const UMA__USD = '0xeEC819b2e155CC8FEae194F5129f767409e2327c';

// https://optimistic.etherscan.io/address/0x41878779a388585509657CE5Fb95a80050502186
export const STETH__USD = '0x41878779a388585509657CE5Fb95a80050502186';

// https://optimistic.etherscan.io/address/0xc3cda94d924Eb5c1b0b64e05F01487d30dA3f235
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0xc3cda94d924Eb5c1b0b64e05F01487d30dA3f235';

// https://optimistic.etherscan.io/address/0xfBe83018d075bDD6AffBe85E5F1E37f0b43bf1F6
export const Real_GDP_Level = '0xfBe83018d075bDD6AffBe85E5F1E37f0b43bf1F6';

// https://optimistic.etherscan.io/address/0x7f99817d87baD03ea21E05112Ca799d715730efe
export const SUSD__USD = '0x7f99817d87baD03ea21E05112Ca799d715730efe';

// https://optimistic.etherscan.io/address/0x0805fAA94F056C06c2a69e115Aa7633EfD3efDca
export const ALETH__USD = '0x0805fAA94F056C06c2a69e115Aa7633EfD3efDca';

// https://optimistic.etherscan.io/address/0xee35A95c9a064491531493D8b380bC40A4CCd0Da
export const DYDX__USD = '0xee35A95c9a064491531493D8b380bC40A4CCd0Da';

// https://optimistic.etherscan.io/address/0x9dfc79Aaeb5bb0f96C6e9402671981CdFc424052
export const LUSD__USD = '0x9dfc79Aaeb5bb0f96C6e9402671981CdFc424052';

// https://optimistic.etherscan.io/address/0x602eB777BE29Fbe63349A33306bD73Ff333D02bB
export const STX__USD = '0x602eB777BE29Fbe63349A33306bD73Ff333D02bB';

// https://optimistic.etherscan.io/address/0x73A3919a69eFCd5b19df8348c6740bB1446F5ed0
export const MIMATIC__USD = '0x73A3919a69eFCd5b19df8348c6740bB1446F5ed0';

// https://optimistic.etherscan.io/address/0x0ded608AFc23724f614B76955bbd9dFe7dDdc828
export const MATIC__USD = '0x0ded608AFc23724f614B76955bbd9dFe7dDdc828';

// https://optimistic.etherscan.io/address/0x14d2d3a82AeD4019FddDfe07E8bdc485fb0d2249
export const STETH__ETH = '0x14d2d3a82AeD4019FddDfe07E8bdc485fb0d2249';

// https://optimistic.etherscan.io/address/0x372cc5e685115A56F14fa7e4716F1294e04c278A
export const RUNE__USD = '0x372cc5e685115A56F14fa7e4716F1294e04c278A';

// https://optimistic.etherscan.io/address/0xebE1590Be4700994b9b373c860BabeA57b681296
export const Virtune_Stellar_ETP__Proof_of_Reserves = '0xebE1590Be4700994b9b373c860BabeA57b681296';

// https://optimistic.etherscan.io/address/0xBfbb4fE2fB71022DbFE0D4232c8C528bddf9c57f
export const ZRX__USD = '0xBfbb4fE2fB71022DbFE0D4232c8C528bddf9c57f';

// https://optimistic.etherscan.io/address/0x0E09921cf7801A5aD47B892C8727593275625a9f
export const TRX__USD = '0x0E09921cf7801A5aD47B892C8727593275625a9f';

// https://optimistic.etherscan.io/address/0x37AAFb2EE35F1250A001202C660B13c301D2130b
export const Synthetix_Aggregator_Issued_Synths = '0x37AAFb2EE35F1250A001202C660B13c301D2130b';

// https://optimistic.etherscan.io/address/0x089730f866C6D478398ce1632C7C38677c475EC1
export const uniBTC__BTC_Exchange_Rate = '0x089730f866C6D478398ce1632C7C38677c475EC1';

// https://optimistic.etherscan.io/address/0xD38579f7cBD14c22cF1997575eA8eF7bfe62ca2c
export const BNB__USD = '0xD38579f7cBD14c22cF1997575eA8eF7bfe62ca2c';

// https://optimistic.etherscan.io/address/0x30795BeACc0f43920EF1288dB6676B5e205AE288
export const ORDI__USD = '0x30795BeACc0f43920EF1288dB6676B5e205AE288';

// https://optimistic.etherscan.io/address/0x5535e67d8f99c8ebe961E1Fc1F6DDAE96FEC82C9
export const INR__USD = '0x5535e67d8f99c8ebe961E1Fc1F6DDAE96FEC82C9';

// https://optimistic.etherscan.io/address/0xBf5384854988939729E8B76b8AeCe7d8D930F9f3
export const ALGO__USD = '0xBf5384854988939729E8B76b8AeCe7d8D930F9f3';

// https://optimistic.etherscan.io/address/0xA369969F522Fda5Ce1D3823d07A393C27b74f723
export const Real_GDP_Percent_Change_Annual_Rate = '0xA369969F522Fda5Ce1D3823d07A393C27b74f723';

// https://optimistic.etherscan.io/address/0x90da1D1DB26c0A84164Ff03090e0B31Ad08A137A
export const rswETH__ETH_Exchange_Rate = '0x90da1D1DB26c0A84164Ff03090e0B31Ad08A137A';

// https://optimistic.etherscan.io/address/0x48f2EcF0Bd180239AEF474a9da945F2e2d41daA3
export const APT__USD = '0x48f2EcF0Bd180239AEF474a9da945F2e2d41daA3';

// https://optimistic.etherscan.io/address/0x89178957E9bD07934d7792fFc0CF39f11c8C2B1F
export const APE__USD = '0x89178957E9bD07934d7792fFc0CF39f11c8C2B1F';

// https://optimistic.etherscan.io/address/0x34E0E85CeEc6be6146c4f0115769a29a9539222e
export const FLOKI__USD = '0x34E0E85CeEc6be6146c4f0115769a29a9539222e';

// https://optimistic.etherscan.io/address/0x73b8BE3b653c5896BC34fC87cEBC8AcF4Fb7A545
export const wrsETH_ETH_Exchange_Rate = '0x73b8BE3b653c5896BC34fC87cEBC8AcF4Fb7A545';

// https://optimistic.etherscan.io/address/0xfa042d5F474d7A39454C594CCfE014Ea011495f2
export const GRT__USD = '0xfa042d5F474d7A39454C594CCfE014Ea011495f2';

// https://optimistic.etherscan.io/address/0x30D9d31C1ac29Bc2c2c312c1bCa9F8b3D60e2376
export const BAL__USD = '0x30D9d31C1ac29Bc2c2c312c1bCa9F8b3D60e2376';

// https://optimistic.etherscan.io/address/0x0f2Ed59657e391746C1a097BDa98F2aBb94b1120
export const VELODROME__USD = '0x0f2Ed59657e391746C1a097BDa98F2aBb94b1120';

// https://optimistic.etherscan.io/address/0x30F6ffb911ac7B9aDF471f28366ce1826C05776e
export const USD1__USD = '0x30F6ffb911ac7B9aDF471f28366ce1826C05776e';

// https://optimistic.etherscan.io/address/0x0D276FC14719f9292D5C1eA2198673d1f4269246
export const OP__USD = '0x0D276FC14719f9292D5C1eA2198673d1f4269246';

// https://optimistic.etherscan.io/address/0x70843CE8E54d2b87Ee02B1911c06EA5632cd07d3
export const wOETH__OETH_Exchange_Rate = '0x70843CE8E54d2b87Ee02B1911c06EA5632cd07d3';

// https://optimistic.etherscan.io/address/0xFAD40C0e2BeF93c6a822015863045CAAeAAde4d3
export const ezETH__ETH_Exchange_Rate = '0xFAD40C0e2BeF93c6a822015863045CAAeAAde4d3';

// https://optimistic.etherscan.io/address/0x46C627150f7993CB71F12E158478546F5Fe060FF
export const yUSD__USD_Exchange_Rate = '0x46C627150f7993CB71F12E158478546F5Fe060FF';

// https://optimistic.etherscan.io/address/0x799A346e7dBfa0f66Ad0961259366F93A1ee34C4
export const XLM__USD = '0x799A346e7dBfa0f66Ad0961259366F93A1ee34C4';

// https://optimistic.etherscan.io/address/0xd2AdD08d9Cd83720c9296A991ce066BB08265eAc
export const sfrxETH__frxETH_Exchange_Rate = '0xd2AdD08d9Cd83720c9296A991ce066BB08265eAc';

// https://optimistic.etherscan.io/address/0x6C7f319E76456749Ee291EdB8bD0027e5E5d3298
export const Virtune_Bitcoin_Prime_ETP__Proof_of_Reserves =
  '0x6C7f319E76456749Ee291EdB8bD0027e5E5d3298';

// https://optimistic.etherscan.io/address/0xb7B9A39CC63f856b90B364911CC324dC46aC1770
export const ETC__USD = '0xb7B9A39CC63f856b90B364911CC324dC46aC1770';

// https://optimistic.etherscan.io/address/0x8d8bEC17703Ac4BbdB42d3e4741C933a0d9a7331
export const Virtune_Staked_Polkadot_ETP__Proof_of_Reserves =
  '0x8d8bEC17703Ac4BbdB42d3e4741C933a0d9a7331';

// https://optimistic.etherscan.io/address/0x5eb9F7baCd59C886fBD9aa2C0a891223482a1ed4
export const JUP__USD = '0x5eb9F7baCd59C886fBD9aa2C0a891223482a1ed4';

// https://optimistic.etherscan.io/address/0x371EAD81c9102C9BF4874A9075FFFf170F2Ee389
export const L2_Sequencer_Uptime_Status_Feed = '0x371EAD81c9102C9BF4874A9075FFFf170F2Ee389';

// https://optimistic.etherscan.io/address/0x2FCF37343e916eAEd1f1DdaaF84458a359b53877
export const SNX__USD = '0x2FCF37343e916eAEd1f1DdaaF84458a359b53877';

// https://optimistic.etherscan.io/address/0x4D4f9BF097DfE85C513E29D770e7CaceD9C07801
export const ynETH__ETH_Exchange_Rate = '0x4D4f9BF097DfE85C513E29D770e7CaceD9C07801';

// https://optimistic.etherscan.io/address/0x26Fce884555FAe5F0E4701cc976FE8D8bB111A38
export const IMX__USD = '0x26Fce884555FAe5F0E4701cc976FE8D8bB111A38';

// https://optimistic.etherscan.io/address/0xCc232dcFAAE6354cE191Bd574108c1aD03f86450
export const LINK__USD = '0xCc232dcFAAE6354cE191Bd574108c1aD03f86450';

// https://optimistic.etherscan.io/address/0xAE33e077a02071E62d342E449Afd9895b016d541
export const SAND__USD = '0xAE33e077a02071E62d342E449Afd9895b016d541';

// https://optimistic.etherscan.io/address/0xD7bC56BBF8D555936cb5121f38d1d362c586776A
export const TIA__USD = '0xD7bC56BBF8D555936cb5121f38d1d362c586776A';

// https://optimistic.etherscan.io/address/0x75c3bF05EeF2c1966D6d5890Def3DbE640627642
export const WIF__USD = '0x75c3bF05EeF2c1966D6d5890Def3DbE640627642';

// https://optimistic.etherscan.io/address/0x028F7347Df25220DA7D63eB7c29fa10448231489
export const instETH__ETH_Exchange_Rate = '0x028F7347Df25220DA7D63eB7c29fa10448231489';

// https://optimistic.etherscan.io/address/0x8281Af165B4380c7aa2445F1c93C150EaD336022
export const USR__USD = '0x8281Af165B4380c7aa2445F1c93C150EaD336022';

// https://optimistic.etherscan.io/address/0x138b809B8472fF09Cd3E075E6EcbB2e42D41d870
export const CBETH__ETH = '0x138b809B8472fF09Cd3E075E6EcbB2e42D41d870';

// https://optimistic.etherscan.io/address/0x718A5788b89454aAE3A028AE9c111A29Be6c2a6F
export const WBTC__USD = '0x718A5788b89454aAE3A028AE9c111A29Be6c2a6F';

// https://optimistic.etherscan.io/address/0x39be70E93D2D285C9E71be7f70FC5a45A7777B14
export const AUD__USD = '0x39be70E93D2D285C9E71be7f70FC5a45A7777B14';

// https://optimistic.etherscan.io/address/0xcFdb47A0c2CBF1eBED49b03BC6D15954C81004dB
export const YETH_ETH_Exchange_Rate = '0xcFdb47A0c2CBF1eBED49b03BC6D15954C81004dB';

// https://optimistic.etherscan.io/address/0x5cdC797acCBf57EE2363Fed9701262Abc87a232e
export const YFI__USD = '0x5cdC797acCBf57EE2363Fed9701262Abc87a232e';

// https://optimistic.etherscan.io/address/0x0cD83cC474e69E611d240f0d35D5794361F5e5C2
export const ENJ__USD = '0x0cD83cC474e69E611d240f0d35D5794361F5e5C2';

// https://optimistic.etherscan.io/address/0xe59EBa0D492cA53C6f46015EEa00517F2707dc77
export const wstETH_stETH_Exchange_Rate = '0xe59EBa0D492cA53C6f46015EEa00517F2707dc77';

// https://optimistic.etherscan.io/address/0xE036C2B215B2533BCE1c9D0436728cE8ABE5665D
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0xE036C2B215B2533BCE1c9D0436728cE8ABE5665D';

// https://optimistic.etherscan.io/address/0x4C92f5b4f8AE43D5DB11f4b87e6D9156e064F4F0
export const Virtune_Polygon_ETP__Proof_of_Reserves = '0x4C92f5b4f8AE43D5DB11f4b87e6D9156e064F4F0';

// https://optimistic.etherscan.io/address/0xEEDF0B095B5dfe75F3881Cb26c19DA209A27463a
export const USDe__USD = '0xEEDF0B095B5dfe75F3881Cb26c19DA209A27463a';

// https://optimistic.etherscan.io/address/0xeA2aeD0087A620995Bf609D1bCD76Ea099905138
export const XTZ__USD = '0xeA2aeD0087A620995Bf609D1bCD76Ea099905138';

// https://optimistic.etherscan.io/address/0x90CC16F5493894eff84a5Fedd1dcE297d174fEEf
export const INJ__USD = '0x90CC16F5493894eff84a5Fedd1dcE297d174fEEf';

// https://optimistic.etherscan.io/address/0x8F7bFb42Bf7421c2b34AAD619be4654bFa7B3B8B
export const XAU__USD = '0x8F7bFb42Bf7421c2b34AAD619be4654bFa7B3B8B';

// https://optimistic.etherscan.io/address/0x3E75C48A27b54dEEc3381689CfA9Ce41Ca55C050
export const PCE_Price_Index_Level = '0x3E75C48A27b54dEEc3381689CfA9Ce41Ca55C050';

// https://optimistic.etherscan.io/address/0x805a61D54bb686e57F02D1EC96A1491C7aF40893
export const AXS__USD = '0x805a61D54bb686e57F02D1EC96A1491C7aF40893';

// https://optimistic.etherscan.io/address/0x8f14546d0B960793180ee355B73fA55041a4a356
export const ARB__USD = '0x8f14546d0B960793180ee355B73fA55041a4a356';

// https://optimistic.etherscan.io/address/0xbD92C6c284271c227a1e0bF1786F468b539f51D9
export const CRV__USD = '0xbD92C6c284271c227a1e0bF1786F468b539f51D9';

// https://optimistic.etherscan.io/address/0xb4479d436DDa5c1A79bD88D282725615202406E3
export const weETH__ETH = '0xb4479d436DDa5c1A79bD88D282725615202406E3';

// https://optimistic.etherscan.io/address/0x338ed6787f463394D24813b297401B9F05a8C9d1
export const AAVE__USD = '0x338ed6787f463394D24813b297401B9F05a8C9d1';

// https://optimistic.etherscan.io/address/0xEF89db2eA46B4aD4E333466B6A486b809e613F39
export const ATOM__USD = '0xEF89db2eA46B4aD4E333466B6A486b809e613F39';

// https://optimistic.etherscan.io/address/0xb429DE60943a8e6DeD356dca2F93Cd31201D9ed0
export const RETH__ETH = '0xb429DE60943a8e6DeD356dca2F93Cd31201D9ed0';

// https://optimistic.etherscan.io/address/0x72155D46FD9f03AF1739637F9E7Db8A87C40A730
export const SUSHI__USD = '0x72155D46FD9f03AF1739637F9E7Db8A87C40A730';

// https://optimistic.etherscan.io/address/0x11429eE838cC01071402f21C219870cbAc0a59A0
export const UNI__USD = '0x11429eE838cC01071402f21C219870cbAc0a59A0';

// https://optimistic.etherscan.io/address/0xe3Ec83f2EE37f7AF2B2711e8aF7554D01B963550
export const wstUSR__stUSR_Exchange_Rate = '0xe3Ec83f2EE37f7AF2B2711e8aF7554D01B963550';

// https://optimistic.etherscan.io/address/0x98FB6366E71E9A71C247052d447E928303e17bB6
export const ankrETH__ETH_Exchange_Rate = '0x98FB6366E71E9A71C247052d447E928303e17bB6';

// https://optimistic.etherscan.io/address/0xC6066533917f034Cf610c08e1fe5e9c7eADe0f54
export const DOGE__USD = '0xC6066533917f034Cf610c08e1fe5e9c7eADe0f54';

// https://optimistic.etherscan.io/address/0xFCdb9EaD2F752AD002Cdf8FcB08Caac4A3402375
export const AAVE_Network_Emergency_Count_Optimism = '0xFCdb9EaD2F752AD002Cdf8FcB08Caac4A3402375';

// https://optimistic.etherscan.io/address/0x64Ecf089a6594Be781908D5a26FC8fA6CB08A2C7
export const PEPE__USD = '0x64Ecf089a6594Be781908D5a26FC8fA6CB08A2C7';

// https://optimistic.etherscan.io/address/0x22Ba046769b584c3B05530F7c50d0E8638bd71F1
export const POL__USD = '0x22Ba046769b584c3B05530F7c50d0E8638bd71F1';

// https://optimistic.etherscan.io/address/0xe4b9bcD7d0AA917f19019165EB89BdbbF36d2cBe
export const ETH__BTC = '0xe4b9bcD7d0AA917f19019165EB89BdbbF36d2cBe';

// https://optimistic.etherscan.io/address/0x72EC6bF88effEd88290C66DCF1bE2321d80502f5
export const weETH__eETH_Exchange_Rate = '0x72EC6bF88effEd88290C66DCF1bE2321d80502f5';

// https://optimistic.etherscan.io/address/0xC663315f7aF904fbbB0F785c32046dFA03e85270
export const SOL__USD = '0xC663315f7aF904fbbB0F785c32046dFA03e85270';

// https://optimistic.etherscan.io/address/0x60025324DAB37DB3A623ea59Cc567937821EeA12
export const OUSDT__USD = '0x60025324DAB37DB3A623ea59Cc567937821EeA12';

// https://optimistic.etherscan.io/address/0x4e8e8F5b3d0f49e00F3DFb9CF827d1A0FBe33B21
export const tETH__wstETH_Exchange_Rate = '0x4e8e8F5b3d0f49e00F3DFb9CF827d1A0FBe33B21';

// https://optimistic.etherscan.io/address/0x33E047119359161288bcB143e0C15467C7151d4c
export const BCH__USD = '0x33E047119359161288bcB143e0C15467C7151d4c';

// https://optimistic.etherscan.io/address/0xCb93226806156b03c8896bbD1cd5e4174cdb0806
export const ynETHx__ETH_Exchange_Rate = '0xCb93226806156b03c8896bbD1cd5e4174cdb0806';

// https://optimistic.etherscan.io/address/0x9651C988e590E571b28561c05aF5598d3e73cA31
export const Virtune_Arbitrum_ETP__Proof_of_Reserves = '0x9651C988e590E571b28561c05aF5598d3e73cA31';

// https://optimistic.etherscan.io/address/0x1520874FC216f5F07E03607303Df2Fda6C3Fc203
export const ZIL__USD = '0x1520874FC216f5F07E03607303Df2Fda6C3Fc203';

// https://optimistic.etherscan.io/address/0xf37c76163b2918bB4533579D449524F8542E64AD
export const FET__USD = '0xf37c76163b2918bB4533579D449524F8542E64AD';

// https://optimistic.etherscan.io/address/0x22F3727be377781d1579B7C9222382b21c9d1a8f
export const rETH_ETH_Exchange_Rate = '0x22F3727be377781d1579B7C9222382b21c9d1a8f';

// https://optimistic.etherscan.io/address/0x3626369857A10CcC6cc3A6e4f5C2f5984a519F20
export const EUR__USD = '0x3626369857A10CcC6cc3A6e4f5C2f5984a519F20';

// https://optimistic.etherscan.io/address/0x58F23F80bF389DB1af9e3aA8c59679806749A8a4
export const PENDLE__USD = '0x58F23F80bF389DB1af9e3aA8c59679806749A8a4';

// https://optimistic.etherscan.io/address/0xECef79E109e997bCA29c1c0897ec9d7b03647F5E
export const USDT__USD = '0xECef79E109e997bCA29c1c0897ec9d7b03647F5E';

// https://optimistic.etherscan.io/address/0xADE082c91A6AeCC86fC11704a830e933e1b382eA
export const RPL__USD = '0xADE082c91A6AeCC86fC11704a830e933e1b382eA';

// https://optimistic.etherscan.io/address/0x4e1C6B168DCFD7758bC2Ab9d2865f1895813D236
export const WLD__USD = '0x4e1C6B168DCFD7758bC2Ab9d2865f1895813D236';

// https://optimistic.etherscan.io/address/0x21515B1Da412ecdCa071a84f32193eD90D4ddb59
export const apxETH__pxETH_Exchange_Rate = '0x21515B1Da412ecdCa071a84f32193eD90D4ddb59';

// https://optimistic.etherscan.io/address/0x66F61FEe824c1dF059BccCC5F21ca39e083EefDf
export const FIL__USD = '0x66F61FEe824c1dF059BccCC5F21ca39e083EefDf';

// https://optimistic.etherscan.io/address/0xd1e56e7657C0E0d20c0e11C2B6ae0D90932d5665
export const SHIB__USD = '0xd1e56e7657C0E0d20c0e11C2B6ae0D90932d5665';

// https://optimistic.etherscan.io/address/0x221618871470f78D8a3391d35B77dFb3C0fbc383
export const LDO__USD = '0x221618871470f78D8a3391d35B77dFb3C0fbc383';

// https://optimistic.etherscan.io/address/0x03fe94a215E3842deD931769F913d93FF33d0051
export const RSETH__ETH = '0x03fe94a215E3842deD931769F913d93FF33d0051';

// https://optimistic.etherscan.io/address/0x43dEa17DeE1ca50c6266acb59b32659E44D3ee5D
export const ADA__USD = '0x43dEa17DeE1ca50c6266acb59b32659E44D3ee5D';

// https://optimistic.etherscan.io/address/0x640349aa5A2A37ad628F9c934Dd78A3Dd45F7933
export const Virtune_Bitcoin_ETP__Proof_of_Reserves = '0x640349aa5A2A37ad628F9c934Dd78A3Dd45F7933';

// https://optimistic.etherscan.io/address/0x675aF77D9266BF28042b0965C11e223153C51aFd
export const Virtune_Staked_Ethereum_ETP__Proof_of_Reserves =
  '0x675aF77D9266BF28042b0965C11e223153C51aFd';

// https://optimistic.etherscan.io/address/0x50f8cf458E7334Be143f3c9F1f1577EE37A45653
export const SATS__USD = '0x50f8cf458E7334Be143f3c9F1f1577EE37A45653';

// https://optimistic.etherscan.io/address/0xB22900D4D0CEa5DB0B3bb08565a9f0f4a831D32C
export const BRL__USD = '0xB22900D4D0CEa5DB0B3bb08565a9f0f4a831D32C';

// https://optimistic.etherscan.io/address/0x37677A136CD3ff2767107D34cfC9213aa474f2BA
export const agETH_ETH_Exchange_Rate = '0x37677A136CD3ff2767107D34cfC9213aa474f2BA';

// https://optimistic.etherscan.io/address/0xF4d48d48C177C4CcBb95F8cbe62619A80a992A99
export const HAI__USD = '0xF4d48d48C177C4CcBb95F8cbe62619A80a992A99';

// https://optimistic.etherscan.io/address/0x2a8D91686A048E98e6CCF1A89E82f40D14312672
export const XMR__USD = '0x2a8D91686A048E98e6CCF1A89E82f40D14312672';

// https://optimistic.etherscan.io/address/0xec236454209A76a6deCdf5C1183aE2Eb5e82a829
export const BONK__USD = '0xec236454209A76a6deCdf5C1183aE2Eb5e82a829';

// https://optimistic.etherscan.io/address/0xA12CDDd8e986AF9288ab31E58C60e65F2987fB13
export const PERP__USD = '0xA12CDDd8e986AF9288ab31E58C60e65F2987fB13';

// https://optimistic.etherscan.io/address/0xca6fa4b8CB365C02cd3Ba70544EFffe78f63ac82
export const NEAR__USD = '0xca6fa4b8CB365C02cd3Ba70544EFffe78f63ac82';

// https://optimistic.etherscan.io/address/0x0838cFe6A97C9CE1611a6Ed17252477a3c71eBEb
export const PYTH__USD = '0x0838cFe6A97C9CE1611a6Ed17252477a3c71eBEb';

// https://optimistic.etherscan.io/address/0x51E06250C8E46c8E5DE41ac8B917a47D706128C2
export const MAV__USD = '0x51E06250C8E46c8E5DE41ac8B917a47D706128C2';

// https://optimistic.etherscan.io/address/0x464A1515ADc20de946f8d0DEB99cead8CEAE310d
export const LINK__ETH = '0x464A1515ADc20de946f8d0DEB99cead8CEAE310d';

// https://optimistic.etherscan.io/address/0xa9d0B1F1D7b5C4129b27EcE9a4562B32dB33343C
export const Virtune_Avalanche_ETP__Proof_of_Reserves =
  '0xa9d0B1F1D7b5C4129b27EcE9a4562B32dB33343C';

// https://optimistic.etherscan.io/address/0x28e67BAeEB5dE7A788f3Dde6CF6ee491369Bb3Fa
export const DOT__USD = '0x28e67BAeEB5dE7A788f3Dde6CF6ee491369Bb3Fa';

// https://optimistic.etherscan.io/address/0x0C194aE5819c4631c58A2849051b269e57A3B657
export const YBTC_BTC_Exchange_Rate = '0x0C194aE5819c4631c58A2849051b269e57A3B657';

// https://optimistic.etherscan.io/address/0x6f6cED6B096708C1276056fdBdb7BbDe07Ca462C
export const SEI__USD = '0x6f6cED6B096708C1276056fdBdb7BbDe07Ca462C';

// https://optimistic.etherscan.io/address/0x4244c9aE5B97269B7301B622E22932FA49fBb763
export const mooBIFI__USD = '0x4244c9aE5B97269B7301B622E22932FA49fBb763';

// https://optimistic.etherscan.io/address/0xFC3b7bd4368b2919f67E437f8c6Ca42C7FD55dd5
export const JTO__USD = '0xFC3b7bd4368b2919f67E437f8c6Ca42C7FD55dd5';

// https://optimistic.etherscan.io/address/0x5087Dc69Fd3907a016BD42B38022F7f024140727
export const AVAX__USD = '0x5087Dc69Fd3907a016BD42B38022F7f024140727';

// https://optimistic.etherscan.io/address/0xe1011160d78a80E2eEBD60C228EEf7af4Dfcd4d7
export const COMP__USD = '0xe1011160d78a80E2eEBD60C228EEf7af4Dfcd4d7';

// https://optimistic.etherscan.io/address/0x536944c3A71FEb7c1E5C66Ee37d1a148d8D8f619
export const JPY__USD = '0x536944c3A71FEb7c1E5C66Ee37d1a148d8D8f619';

// https://optimistic.etherscan.io/address/0x8788F0DBDa7678244Ac7FF09d963d7696D56A8a0
export const XRP__USD = '0x8788F0DBDa7678244Ac7FF09d963d7696D56A8a0';

// https://optimistic.etherscan.io/address/0x2FF8822F371b283604369700d6F06da3fBb31064
export const ZEC__USD = '0x2FF8822F371b283604369700d6F06da3fBb31064';

// https://optimistic.etherscan.io/address/0x7F102e5b4C32e0861293E97DE85e6E0dB3530605
export const WELL__USD = '0x7F102e5b4C32e0861293E97DE85e6E0dB3530605';

// https://optimistic.etherscan.io/address/0x517C2557c29F7c53Aa5F97a1DAE465E0d5C174AA
export const BLUR__USD = '0x517C2557c29F7c53Aa5F97a1DAE465E0d5C174AA';

// https://optimistic.etherscan.io/address/0x8dBa75e83DA73cc766A7e5a0ee71F656BAb470d6
export const DAI__USD = '0x8dBa75e83DA73cc766A7e5a0ee71F656BAb470d6';

// https://optimistic.etherscan.io/address/0x9fCe737834500045FB07AD158991BCAC3b05D5A6
export const _1INCH__USD = '0x9fCe737834500045FB07AD158991BCAC3b05D5A6';

// https://optimistic.etherscan.io/address/0x8814dEC83E2862A3792A0D6aDFC48CF76Add1890
export const STRK__USD = '0x8814dEC83E2862A3792A0D6aDFC48CF76Add1890';

// https://optimistic.etherscan.io/address/0x5A9072a995E072fD06D8f1EB95933955FDa53C0a
export const CELO__USD = '0x5A9072a995E072fD06D8f1EB95933955FDa53C0a';

// https://optimistic.etherscan.io/address/0x955b05dD4573dDFAfB47cb78db16B1Fa127E6e71
export const CVX__USD = '0x955b05dD4573dDFAfB47cb78db16B1Fa127E6e71';

// https://optimistic.etherscan.io/address/0x290dd71254874f0d4356443607cb8234958DEe49
export const XAG__USD = '0x290dd71254874f0d4356443607cb8234958DEe49';

// https://optimistic.etherscan.io/address/0xe98290265E4aE3758503a03e937F381A2A7aFB57
export const ICP__USD = '0xe98290265E4aE3758503a03e937F381A2A7aFB57';

// https://optimistic.etherscan.io/address/0x16a9FA2FDa030272Ce99B29CF780dFA30361E0f3
export const USDC__USD = '0x16a9FA2FDa030272Ce99B29CF780dFA30361E0f3';

// https://optimistic.etherscan.io/address/0x8Ef4207CBC405085B6740fc931114cAFCD1d9158
export const Virtune_Chainlink_ETP__Proof_of_Reserves =
  '0x8Ef4207CBC405085B6740fc931114cAFCD1d9158';

// https://optimistic.etherscan.io/address/0x85342bC62aadef58f029ab6d17D643949e6F073e
export const sUSDe__USDe_Exchange_Rate = '0x85342bC62aadef58f029ab6d17D643949e6F073e';

// https://optimistic.etherscan.io/address/0xEaf1a9fe242aa9928faedc6CE7e09aD4875f7133
export const SUI__USD = '0xEaf1a9fe242aa9928faedc6CE7e09aD4875f7133';

// https://optimistic.etherscan.io/address/0xCB24d22aF35986aC1feb8874AdBbDF68f6dC2e96
export const KNC__USD = '0xCB24d22aF35986aC1feb8874AdBbDF68f6dC2e96';

// https://optimistic.etherscan.io/address/0xC6884869673a6960486FE0f6B0E775A53521e433
export const MEME__USD = '0xC6884869673a6960486FE0f6B0E775A53521e433';

// https://optimistic.etherscan.io/address/0x8f096bFFe37313Ad6bD5B9fF48F9FF6E4E5Cd065
export const sFRAX__FRAX_Exchange_Rate = '0x8f096bFFe37313Ad6bD5B9fF48F9FF6E4E5Cd065';

// https://optimistic.etherscan.io/address/0x45954efBD01f5A12428A09E4C38b8434C3dD4Ac3
export const LTC__USD = '0x45954efBD01f5A12428A09E4C38b8434C3dD4Ac3';

// https://optimistic.etherscan.io/address/0x3FF5BDB2bB6E3f946d9485De6c591c93B4179ae7
export const TRB__USD = '0x3FF5BDB2bB6E3f946d9485De6c591c93B4179ae7';

export const CHAIN_ID = 10;
